module.exports = __webpack_public_path__ + "img/universkin-o-active-icon.3fed6a67.svg";